import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SubSink } from 'subsink';
import { IterationSetModel } from '../constants/constants';
import { Observable, catchError, finalize, map, of, takeWhile, tap, timer } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AutoMlService {
  subs:SubSink= new SubSink();
  isAutoMl:boolean = false;
  scoreTableData:any[]=[];
  scoreTableDataMaxvalue:number=0;
  comparisonImportenceScore:any[]=[]
  soreImportenceScore:any[]=[]
  scoreGroupData:string[]=[];
  rankTableData:any[]=[];
  rankTableDataMaxvalue:number=0;
  rankGroupData:string[]=[];
  resultPreviewData:any[]=[];
  tableColumns:{ all_columns : string[], target_variables:string[]} = { all_columns :[], target_variables:[]};
  columnSet:any;
  dependentVariable:any;
  isRank:boolean=false;
  isScore:boolean=false;
  rankCompareTableData:any[]=[];
  scoreCompareTableData:any[]=[];
  isInput:boolean = false;
  iterationSet:IterationSetModel[]=[
    {
      name:'Iteration 1',
      all_columns:[],
      target_columns:[],
      compared_result:[],
      isNameEdit:false,
      isRunLoad:false,
      isOpen:true,
      isAction:false,
      uuid:'',
      color:'#807AED',
      satisfy:false,
      selectScenarioIndex:0,
      scenarioList:[]
    }
  ];
  loaderText:string='Initializing Model Training...';
  isValidDepVariable:boolean=true;
  isSatisfy:boolean=false;
  scenarioSetList:any[]=[];
  scenarioMaxValue:number=1;
  selectedIndex:number=0;
  initialDriversSet:any;
  progressSet:any;
  value:number=0;
  timerSet:boolean = false;
  token!:string;
  correlationMaxValue:number=0;
  
  stepperOptions:any=[
    {
      name:'Load your data',
      step:false,
      last:false
    },
    {
      name:'Run your Model',
      step:false,
      last:false
    },
    {
      name:'Analyze your results',
      step:false,
      last:false
    },
    {
      name:'Re-Analyze your results <br> (Optional)',
      step:false,
      last:false
    },
    {
      name:'Create Scenarios',
      step:false,
      last:false
    }
  ]

  constructor(
    private http:HttpClient,
    private toast:ToastrService,
    private _cookie: CookieService,
  ) { }

  baseUrl:string = 'http://43.204.164.32:8080/api/v1';

  getTableColums(){
    this.subs.add(
      this.getTableColumns()
      .subscribe((res:any)=>{
        this.tableColumns = res;
        this.columnSet = JSON.stringify(this.iterationSet[0].all_columns = this.tableColumns.all_columns.map((el:any)=>{
          return {
            name:el,
            check:false
          }
        }));
        this.iterationSet[0].all_columns= JSON.parse(this.columnSet);
      })
    )
  }

  interval(timeToWait:any):Observable<number>
  {
    const initial = new Date().getTime();
    return timer(0, 200).pipe(
      map(()=> new Date().getTime()),
      takeWhile((res) => res<=initial+timeToWait,true),
      map(now=>{
        const porc = (100 * (now - initial)) / timeToWait;
        return porc<100?Math.round(porc):100
      })
    );
  }

  startIntervel(){
    this.interval(5000).subscribe((res:any)=>{
      if(res>=0 && res < 20){
        this.loaderText = 'Initializing Model Training...';
      }else if(res>20 && res < 40)
      {
        this.loaderText = 'Optimizing Model Parameters. This may take a few moments...';
      }else if(res>40 && res < 60)
      {
        this.loaderText = 'Data Preprocessing in Progress...';
      }else if(res>60 && res < 80){
        this.loaderText = 'Training in Progress';
      }else if(res>80 && res < 100){
        this.loaderText = 'Almost There! Model Fine-Tuning in Progress...';
      }else{
        this.loaderText = 'Training Completed Successfully!';      
      }

      this.value = res;
    });
  }

  runIterationSet(iterateIndex:number){
    this.selectedIndex = iterateIndex;
    if(this.dependentVariable===undefined){
      this.isValidDepVariable=false;
      return;
    }

    this.iterationSet[iterateIndex].isRunLoad = true;
    
    let data:any={
      target_variable:this.dependentVariable
    }
    let selectedColumns:any;

    if(iterateIndex>0){
       selectedColumns = this.iterationSet[iterateIndex].all_columns.filter((res:any)=>{
        return res.check
      })
      .map((data:any)=>{
        return data.name
      })
      data['selected_columns'] = selectedColumns;
    }

    this.startIntervel();


    this.subs.add(
      this.runIteration(data)
      .pipe(
        finalize(()=>{
          this.iterationSet[iterateIndex].isRunLoad = false;
        }),
        catchError((e:any)=>{
          if(iterateIndex===0){
            this.dependentVariable = undefined;
          }
          this.toast.error(e?.error?.error,'Error')
          return of(false)
        })
      )
      .subscribe((res:any)=>{
          if(res.output_columns){
            this.iterationSet[iterateIndex].target_columns = res.output_columns;
            this.iterationSet[iterateIndex].uuid = res.uuid;
            this.iterationSet[iterateIndex].accuracy_data = res.accuracy_data;
            this.setCompareArray(iterateIndex,selectedColumns);
            this.getTableDetails();
            this.comparisonData();

            if(iterateIndex===0){
              this.stepperOptions[1].step=true;
              this.stepperOptions[2].step=true;
              this.stepperOptions[2].last=true;
            }else{
              this.stepperOptions[2].last=false;
              this.stepperOptions[3].last=true;
              this.stepperOptions[3].step=true;
            }
            if(iterateIndex===0){
              this.getCorrelationValue();
            }

            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          }
      })
    )
  }

  getCorrelationValue(){
    let columnSet = JSON.parse(this.columnSet);
    let data:any={
      target_variable:this.dependentVariable
    }
    this.correlationValue(data)
    .subscribe((res:any)=>{
      columnSet = columnSet.map((el:any)=>{
        return {
          ...el,
          co_value:res[el.name]
        }
      });
      let clearSet = columnSet.filter((el:any)=>{return el.co_value && el.name !== this.dependentVariable})
      let maxValue = Math.max(...clearSet.map((o:any) => o.co_value));
      let minValue = Math.min(...clearSet.map((o:any) => o.co_value));
      this.correlationMaxValue = Math.abs(minValue) > maxValue ? Math.abs(minValue): maxValue;
      this.columnSet = JSON.stringify(columnSet);
    })
  }


  setCompareArray(index:number,selectedColumns:any){
    
    let allColums = this.iterationSet[index].all_columns;
    let target_columns = this.iterationSet[index].target_columns;
    let compared:any[]=[];

    allColums.forEach((el:any)=>{
      if(el.name !== this.dependentVariable)
      {
        compared.push({
          name:el.name,
          remove:!target_columns.includes(el.name),
          selected: selectedColumns!==undefined ? selectedColumns.includes(el.name) : true
        })
      }
    });
    this.iterationSet[index].compared_result = compared;
  }

  addIterationSet(){
    let color='';
    switch (this.iterationSet.length) {
      case 0:
        color ='#807AED';
        break;
      case 1:
        color ='#3BD6AD';
        break;
      case 2:
        color ='#3267FF';
        break;
      case 3:
        color ='#FFB300';
        break;
    
      default:
        break;
    }
    
    this.iterationSet.push(
      {
        name:'Iteration '+(this.iterationSet.length+1),
        all_columns:JSON.parse(this.columnSet).filter((el:any)=>{ return el.name !== this.dependentVariable}),
        target_columns:[],
        compared_result:[],
        isNameEdit:false,
        isRunLoad:false,
        isOpen:true,
        isAction:true,
        uuid:'',
        color:color,
        satisfy:false,
        selectScenarioIndex:0,
        scenarioList:[]
      }
    );

    this.selectedIndex = this.iterationSet.length-1;
    this.loaderText='Initializing Model Training...';
    this.value=0;

    this.iterationSet.forEach((element:any,i:number) => {
      if(i!==this.iterationSet.length-1){
        element.isOpen = false
      }
    });
    if(this.selectedIndex===1){
      this.stepperOptions[2].last = false
    }

  }

  getTableDetails(){
    this.getResultDetails()
    .subscribe((res:any)=>{
      this.resultPreviewData =  res;
    })
  }

  comparisonData(){
    this.scoreTableData=[];
    this.rankTableData=[];
    this.rankCompareTableData=[];
    this.scoreCompareTableData=[];

    this.getComparisonData()
    .subscribe((res:any)=>{

      let itration:any=[[],[],[],[]];
      let accuracy:any=[];
      this.comparisonImportenceScore=[];
      this.soreImportenceScore =[];
      res.importance_score_data.forEach((el:any,j:number) => {

        this.scoreGroupData.push(el.variable_name);


        let set = el.iteration_score_data.map((el1:any,i:number)=>{

          // if(el.iteration_score_data[i].score !== null){
            itration[i].push({
              name: el.variable_name,
              value: el.iteration_score_data[i].score !== null ? el.iteration_score_data[i].score : '-'
            })
          // }
          accuracy.push(el1.accuracy_data)

          let color;
          switch (i) {
            case 0:
              color ='#807AED';
              break;
            case 1:
              color ='#3BD6AD';
              break;
            case 2:
              color ='#3267FF';
              break;
            case 3:
              color ='#FFB300';
              break;
          
            default:
              break;
          }
          return {
            value:el1.score,
            color:color
          }
        });

        this.scoreTableDataMaxvalue = this.scoreTableDataMaxvalue < Math.max(...set.map((o:any) => o.value)) ? Math.max(...set.map((o:any) => o.value)) : this.scoreTableDataMaxvalue; 
        this.scoreTableData.push(set);
        
       
      });

    
      
      

      itration.filter((el:any)=>{ return el.length >0}).forEach((el:any,j:number) => {
        this.comparisonImportenceScore.push({
          data:el,
          accuracy:accuracy[j]
        })
      });
      
      

      let itration2:any=[[],[],[],[]];
      let accuracy2:any=[];
      res.rank_data.forEach((el:any,j:number) => {
        this.rankGroupData.push(el.variable_name);
        let set = el.iteration_rank_data.map((el1:any,i:number)=>{

            itration2[i].push({
              name: el.variable_name,
              value: el.iteration_rank_data[i].rank !== null ? el.iteration_rank_data[i].rank :'-'
            })

          accuracy2.push(el1.accuracy_data)

          let color;
          switch (i) {
            case 0:
              color ='#807AED';
              break;
            case 1:
              color ='#3BD6AD';
              break;
            case 2:
              color ='#3267FF';
              break;
            case 3:
              color ='#FFB300';
              break;
          
            default:
              break;
          }
          return {
            value:el1.rank,
            color:color
          }
        });
        this.rankTableDataMaxvalue = this.rankTableDataMaxvalue < Math.max(...set.map((o:any) => o.value)) ? Math.max(...set.map((o:any) => o.value)) : this.rankTableDataMaxvalue; 
        this.rankTableData.push(set);

      });

      itration2.filter((el:any)=>{ return el.length >0}).forEach((el:any,j:number) => {
        this.soreImportenceScore.push({
          data:el,
          accuracy:accuracy[j]
        })
      });

       res.rank_data.forEach((el:any)=>{
        let element:any =  {
          Variable:el.variable_name,
        }
        el.iteration_rank_data.forEach((el2:any)=>{
          element[el2.name] =el2.rank
        })
        this.rankCompareTableData.push(element) 
      })

       res.importance_score_data.forEach((el:any)=>{
        let element:any =  {
          Variable:el.variable_name,
        }
        el.iteration_score_data.forEach((el2:any)=>{
          element[el2.name] =el2.score
        })
        this.scoreCompareTableData.push(element) 
  
      })

     
    })
  }


  getVariableDetails(){
    this.variableMinMax()
    .subscribe((res:any)=>{
      let drivers:any[]=[];
      res.map((el:any)=>{
        
        if(!isNaN(Number(el.max_value)+1) && this.iterationSet[this.selectedIndex].target_columns.includes(el.Feature) && el.max_value !==null)
        {
          drivers.push({...el,value:(((Number(el.max_value)-Number(el.min_value))/2)+Number(el.min_value)).toFixed(2)});
        }
      });
      
      this.iterationSet[this.selectedIndex].scenarioList.push({driversList:drivers,isEdit:true});
      this.initialDriversSet = JSON.stringify(drivers);

      this.stepperOptions[3].last=false;
      this.stepperOptions[4].step=true;
      this.stepperOptions[4].last=true;

      this.runScenario(0);
    })
  }


  runScenario(i:number){
    
    let data:any={};
    this.iterationSet[this.selectedIndex].all_columns.forEach((element:any) => {
      let item = this.iterationSet[this.selectedIndex].scenarioList[i].driversList?.find((el:any)=>el.Feature ===element.name);
      data[element.name] = item ? Number(item.value) : 0
    });
    this.runScenarioApi(this.iterationSet[this.selectedIndex].uuid,data)
    .pipe(
      catchError((e:any)=>{
        this.toast.error(e?.error?.error,'Error')
        return of(false)
      })
    )
    .subscribe((el:any)=>{
      this.iterationSet[this.selectedIndex].scenarioList[i] = {...this.iterationSet[this.selectedIndex].scenarioList[i],...el} 
    })
  }

  updateScenarioSet(i:number){
    let item ={
      driversList : this.iterationSet[this.selectedIndex].scenarioList[i].driversList
    }
    let data:any={};
    this.iterationSet[this.selectedIndex].all_columns.forEach((element:any) => {
      let item = this.iterationSet[this.selectedIndex].scenarioList[i].driversList?.find((el:any)=>el.Feature ===element.name);
      data[element.name] = item ? Number(item.value) : 0
    });

    this.updateScenario(this.iterationSet[this.selectedIndex].scenarioList[i].uuid,data)
    .pipe(
      catchError((e:any)=>{
        this.toast.error(e?.error?.error,'Error')
        return of(false)
      })
    )
    .subscribe((res:any)=>{
      // if(res.su)
      // this.scenarioSetList[this.scenarioSetList.length-1] = res;
      // this.scenarioSetList.push({prediction_score:this.scenarioSetList[this.scenarioSetList.length-1].prediction_score,name:'Scenario '+(this.scenarioSetList.length+1)})
      this.iterationSet[this.selectedIndex].scenarioList[i] ={
        ...item,
        default_prediction_output:res.default_prediction_output,
        prediction_output:res.prediction_output,
        uuid:res.uuid,
        name:this.iterationSet[this.selectedIndex].scenarioList[i].name,
        description:this.iterationSet[this.selectedIndex].scenarioList[i].description,
        isEdit:this.iterationSet[this.selectedIndex].scenarioList[i].isEdit}  

     
      
    })
    
  }


  allscenarioList(){
    this.scenarioList().subscribe((res:any)=>{
      this.iterationSet[this.selectedIndex].scenarioList = res;
      // this.iterationSet[this.iterationSet.length-1].scenarioMaxValue = Math.max(...res.map((o:any) => o.prediction_score))
    });
  }

  getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
        c = ca[i].replace(/^\s+/g, '');
        if (c.indexOf(cookieName) == 0) {
            return c.substring(cookieName.length, c.length);
        }
    }
    return '';
  }




  // API CALLS

 httpOptions = {
    headers: new HttpHeaders({
      Authorization: `Token ${this.token}`
  })
 }

  //-> Login

  loginEtl(data: any) {
    return this.http.post(`${this.baseUrl}/login/`, data);
  }

  logoutEtl(){
    return this.http.post(`${this.baseUrl}/logout/`,'',this.httpOptions);
  }



  fileUpload(data: any) {
    return this.http.post(`${this.baseUrl}/file-upload/`, data,this.httpOptions);
  }

  runIteration(data: any) {
    return this.http.post(`${this.baseUrl}/run/iteration/`, data,this.httpOptions);
  }

  getTableColumns() {
    return this.http.get(`${this.baseUrl}/iteration/source-data/columns/`,this.httpOptions);
  }

  renameIterateName(uuid:string,data:any){
    return this.http.patch(`${this.baseUrl}/iteration/${uuid}/`,data,this.httpOptions);
  }

  deleteIteration(uuid:string){
    return this.http.delete(`${this.baseUrl}/iteration/${uuid}/`,this.httpOptions);
  }

  getResultDetails(){
    return this.http.get(`${this.baseUrl}/iteration/results/`,this.httpOptions);
  }

  getComparisonData(){
    return this.http.get(`${this.baseUrl}/iteration/comparison/`,this.httpOptions);
  }

  getVariables(){
    return this.http.get(`${this.baseUrl}/iteration/variables/`,this.httpOptions);
  }
  
  runScenarioApi(objId:string,data:any){
    return this.http.post(`${this.baseUrl}/iteration/${objId}/scenario/`,data,this.httpOptions);
  }

  variableMinMax(){
    return this.http.get(`${this.baseUrl}/iteration/variables/`,this.httpOptions);
  }

  scenarioList(){
    return this.http.get(`${this.baseUrl}/scenario-list/`,this.httpOptions);
  }

  updateScenario(id:string,data:any){
    return this.http.post(`${this.baseUrl}/scenario/${id}/re-run/`,data,this.httpOptions);
  }

  renameScenario(id:string,data:any){ 
    return this.http.put(`${this.baseUrl}/scenario/${id}/`,data,this.httpOptions);
  }

  deleteScenario(id:string){ 
    return this.http.delete(`${this.baseUrl}/scenario/${id}/`,this.httpOptions);
  }

  correlationValue(data:any){ 
    return this.http.post(`${this.baseUrl}/correlation-with-target/`,data,this.httpOptions);
  }

  uploadFile(data:FormData){
    return this.http.post(`${this.baseUrl}/file-upload/new/`,data,this.httpOptions);
  }


}
